import { observer } from 'mobx-react-lite';
import { Navigate, Outlet } from 'react-router-dom';
import { authStore } from '@/stores/authStore';
import Navbar from '../Navbar';
import { useEffect, useState } from 'react';
import { axiosInstance } from '@/utils/axiosConfig';
import { useTranslation } from 'react-i18next';

const AuthLayout = observer(() => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(true);
  const token = localStorage.getItem('accessToken');

  useEffect(() => {
    const validateSession = async () => {
      try {
        if (!token) {
          setLoading(false);
          return;
        }

        // Try to get user data with current token
        const response = await axiosInstance.get('/auth/me');
        authStore.setUser(response.data);
        setLoading(false);
      } catch (error) {
        // If token is invalid, try to refresh
        try {
          const refreshResponse = await axiosInstance.post('/auth/refresh-token', {}, {
            withCredentials: true
          });

          if (refreshResponse.data.accessToken) {
            localStorage.setItem('accessToken', refreshResponse.data.accessToken);
            authStore.setUser(refreshResponse.data.user);
          }
        } catch (refreshError) {
          // If refresh fails, clear everything
          localStorage.removeItem('accessToken');
          authStore.setUser(null);
        }
        setLoading(false);
      }
    };

    validateSession();
  }, [token]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900 mx-auto" />
          <p className="mt-2">{t('common.loading')}</p>
        </div>
      </div>
    );
  }

  if (!token) {
    return <Navigate to="/login" />;
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      <main className="container mx-auto px-3 sm:px-4 py-4 sm:py-8">
        <Outlet />
      </main>
    </div>
  );
});

export default AuthLayout; 